export default {
  order: 10,
  name: "Reports",
  icon: "mdi-file-powerpoint",
  to: "/reporting/Dashboard",
  hasSubs: 0,
  enabled: true,
};
